module.exports = __webpack_public_path__ + "static/media/RABBIT.326c74f8.svg";